import { render, staticRenderFns } from "./OverviewLastPosts.vue?vue&type=template&id=4c9abf70&scoped=true&"
import script from "./OverviewLastPosts.vue?vue&type=script&lang=js&"
export * from "./OverviewLastPosts.vue?vue&type=script&lang=js&"
import style0 from "./OverviewLastPosts.vue?vue&type=style&index=0&id=4c9abf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9abf70",
  null
  
)

export default component.exports